module.exports = __webpack_public_path__ + "img/20190222_183706_006.eb08a191.jpg";